const FIELD_INPUT_SELECTOR = [
  'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([disabled])',
  "textarea:not([disabled])",
].join(", ");

export function shouldIgnoreEnterAdvance(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return true;
  if (target.tagName === "TEXTAREA") return true;
  if (target.isContentEditable) return true;
  if (target.dataset.questionnaireEnterAdvance === "true") return false;
  // Native actions must receive Enter themselves; only answer choices opt into advance.
  if (
    target.closest(
      'button, a, summary, select, [role="button"], input[type="checkbox"], input[type="radio"]',
    ) &&
    !target.closest('[data-questionnaire-choice="true"]')
  )
    return true;
  if (
    target.closest(
      '[role="combobox"], [cmdk-root], [data-radix-popper-content-wrapper], [role="dialog"], [role="listbox"]',
    )
  ) {
    return true;
  }
  return false;
}

export function getStepFieldInputs(container: HTMLElement): HTMLElement[] {
  return Array.from(
    container.querySelectorAll<HTMLElement>(FIELD_INPUT_SELECTOR),
  ).filter(
    (element) =>
      !element.closest("[hidden]") &&
      !element.closest('[role="combobox"]') &&
      !element.closest("[cmdk-root]"),
  );
}

export function getActiveFieldInputIndex(
  focusables: HTMLElement[],
  activeElement: Element | null,
): number {
  if (!activeElement) return -1;
  return focusables.findIndex(
    (element) => element === activeElement || element.contains(activeElement),
  );
}

export function focusFieldInput(element: HTMLElement) {
  element.focus();
  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement
  ) {
    element.select();
  }
}
